import { Toast } from '@leverege/ui-elements';
import { getInvoicePDF } from '../../util/Interface';
export default {
  id: 'billing.downloadInvoice',
  name: 'Download Invoice',
  layout: {
    sort: 'z.billing.1',
    sectionName: 'Billing Downloads'
  },
  matches: {
    use: ['contextMenu', 'mobileActionBar'],
    client: 'ItemInfoScreen',
    objectType: 'bill'
  },
  handles: () => true,
  appearance: () => ({
    name: 'Download Invoice'
  }),
  perform: downloadPDF
};
async function downloadPDF({
  context
}) {
  const systemId = context?.clientProps?.item?.systemId;
  const companyId = context?.clientProps?.item?.data?.company?.id;
  const locationId = context?.clientProps?.item?.data?.location?.id;
  const billingId = context?.clientProps?.item?.id;
  const filename = `RecovR Invoice - ${context?.clientProps?.item?.networkAliases?.['recovr-invoice']?.invoiceId || context?.clientProps?.item?.data?.name}.pdf`; // eslint-disable-line max-len

  try {
    await getInvoicePDF(systemId, companyId, locationId, billingId, filename);
  } catch (err) {
    Toast.error('Error downloading invoice');
  }
}